import React from 'react';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';

//a wrapper component that will be put around each menuItem produced by Platform navigation
// in order to emulate the single error boundary in next/packages/page-layout/src/SideNavigation.tsx
export const DiscoErrorBoundary = ({ children }: { children: React.ReactNode }) => (
	<ErrorBoundary
		attribution={Attribution.DISCO}
		attributes={{
			errorBoundaryId: 'sideNavigation-globalNavigation',
		}}
	>
		{children}
	</ErrorBoundary>
);
